import React, { useState, useEffect, useContext } from 'react';
import CircularLoading from "../components/CircularLoading";
import { useSelector, useDispatch } from "react-redux";
import Button from "components/CustomButtons/Button.js";
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { makeStyles } from '@material-ui/core/styles';
import { language } from "config";
import AlertDialog from '../components/AlertDialog';
import { FirebaseContext } from 'common';
import {
  Select,
  MenuItem,
  FormControl
} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
    width: 192,
    height: 192
  },
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const MyProfile = (props) => {
  const { api } = useContext(FirebaseContext);
  const {
    updateProfile,
    updateLicenseImage,
    updateLogBookImage,
    updateInsuranceImage,
    updateCertificateImage,
    updateVehicleImage
  } = api;
  const auth = useSelector(state => state.auth);
  const dispatch = useDispatch();
  const classes = useStyles();
  const [commonAlert, setCommonAlert] = useState({ open: false, msg: '' });

  const [data, setData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    loginType: null,
    usertype: '',
    carType: props.cars && props.cars.length > 0 ? props.cars[0].value : "",
    vehicleNumber: '',
    vehicleMake: '',
    vehicleModel: '',
    bankAccount: '',
    bankCode: '',
    bankName: '',
    other_info: '',
    licenseImage: null,
    logBookImage: null,
    driversInsurance: null,
    certOfConduct: null,
    vehiclePhoto: null
  });

  const cartypes = useSelector((state) => state.cartypes.cars);
  const [carType, setCarType] = useState(language.select_car);
  const [selectedCarDetails, setSelectedCarDetails] = useState(null);

  const handleCarSelect = (event) => {
    setCarType(event.target.value);
    setData({ ...data, carType: event.target.value });
    let carDetails = null;
    for (let i = 0; i < cartypes.length; i++) {
      if (cartypes[i].name === event.target.value) {
        carDetails = cartypes[i];
      }
    }
    setSelectedCarDetails(carDetails);
  };

  const [licenseImageAsFile, setLicenseImageAsFile] = useState(null);
  const [logBookImageAsFile, setLogBookImageAsFile] = useState(null);
  const [insuranceImageAsFile, setInsuranceImageAsFile] = useState(null);
  const [certificateImageAsFile, setCertificateImageAsFile] = useState(null);
  const [vehicleImageAsFile, setVehicleImageAsFile] = useState(null);
  // const [othersImageAsFile, setOthersImageAsFile] = useState(null);

  const handleLicenseImageAsFile = (e) => {
    const image = e.target.files[0];
    setLicenseImageAsFile(imageFile => (image));
  };
  const handleLogbookImageAsFile = (e) => {
    const image = e.target.files[0];
    setLogBookImageAsFile(imageFile => (image));
  };
  const handleInsuranceImageAsFile = (e) => {
    const image = e.target.files[0];
    setInsuranceImageAsFile(imageFile => (image));
  };
  const handleCertificateImageAsFile = (e) => {
    const image = e.target.files[0];
    setCertificateImageAsFile(imageFile => (image));
  };
  const handleVehicleImageAsFile = (e) => {
    const image = e.target.files[0];
    setVehicleImageAsFile(imageFile => (image));
  };
  // const handleOthersImageAsFile = (e) => {
  //   const image = e.target.files[0];
  //   setOthersImageAsFile(imageFile => (image));
  // };

  useEffect(() => {
    if (auth.info && auth.info.profile) {
      setData({
        firstName: !auth.info.profile.firstName || auth.info.profile.firstName === ' ' ? '' : auth.info.profile.firstName,
        lastName: !auth.info.profile.lastName || auth.info.profile.lastName === ' ' ? '' : auth.info.profile.lastName,
        email: !auth.info.profile.email || auth.info.profile.email === ' ' ? '' : auth.info.profile.email,
        mobile: !auth.info.profile.mobile || auth.info.profile.mobile === ' ' ? '' : auth.info.profile.mobile,
        carType: !auth.info.profile.carType || auth.info.profile.carType === ' ' ? '' : auth.info.profile.carType,
        vehicleNumber: !auth.info.profile.vehicleNumber || auth.info.profile.vehicleNumber === ' ' ? '' : auth.info.profile.vehicleNumber,
        vehicleMake: !auth.info.profile.vehicleMake || auth.info.profile.vehicleMake === ' ' ? '' : auth.info.profile.vehicleMake,
        vehicleModel: !auth.info.profile.vehicleModel || auth.info.profile.vehicleModel === ' ' ? '' : auth.info.profile.vehicleModel,
        bankAccount: !auth.info.profile.bankAccount || auth.info.profile.bankAccount === ' ' ? '' : auth.info.profile.bankAccount,
        bankCode: !auth.info.profile.bankCode || auth.info.profile.bankCode === ' ' ? '' : auth.info.profile.bankCode,
        bankName: !auth.info.profile.bankName || auth.info.profile.bankName === ' ' ? '' : auth.info.profile.bankName,
        loginType: auth.info.profile.loginType ? 'social' : 'email',
        usertype: auth.info.profile.usertype,
        uid: auth.info.uid
      });
    }
  }, [auth.info]);

  const updateData = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    if (re.test(data.email)) {
      dispatch(updateProfile(auth.info, {
        firstName: data.firstName,
        lastName: data.lastName,
        email: data.email,
        mobile: data.mobile,
        carType: data.carType,
        vehicleNumber: data.vehicleNumber,
        vehicleMake: data.vehicleMake,
        vehicleModel: data.vehicleModel,
        bankAccount: data.bankAccount,
        bankCode: data.bankCode,
        bankName: data.bankName
      }));
      if (licenseImageAsFile !== null) { dispatch(updateLicenseImage(Date.parse(auth.info.profile.createdAt), licenseImageAsFile)) };
      if (insuranceImageAsFile !== null) { dispatch(updateInsuranceImage(Date.parse(auth.info.profile.createdAt), insuranceImageAsFile)) };
      if (certificateImageAsFile !== null) { dispatch(updateCertificateImage(Date.parse(auth.info.profile.createdAt), certificateImageAsFile)) };
      if (vehicleImageAsFile !== null) { dispatch(updateVehicleImage(Date.parse(auth.info.profile.createdAt), vehicleImageAsFile)) };
      // if (othersImageAsFile !== null) { dispatch(updateOthersImage(Date.parse(auth.info.profile.createdAt), othersImageAsFile)) };
      if (logBookImageAsFile !== null) { dispatch(updateLogBookImage(Date.parse(auth.info.profile.createdAt), logBookImageAsFile)) };
      setCommonAlert({ open: true, msg: language.profile_updated })
    } else {
      setCommonAlert({ open: true, msg: language.proper_email })
    }
  }

  const handleCommonAlertClose = (e) => {
    e.preventDefault();
    setCommonAlert({ open: false, msg: '' })
  };

  return (
    auth.loading ? <CircularLoading /> :
      <Container component="main" maxWidth="md">
        <CssBaseline />
        <div className={classes.paper}>
          <form className={classes.form} onSubmit={handleSubmit}>
            <div style={{ display: 'flex', flexDirection: 'row' }}>
              <div style={{ marginRight: 10, maxWidth: '30vw' }}>
                <Typography component="h1" variant="h5">
                  {language.profile}
                </Typography>
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="firstName"
                  label={language.firstname}
                  name="firstName"
                  autoComplete="firstName"
                  onChange={updateData}
                  value={data.firstName}
                  autoFocus
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="lastName"
                  label={language.lastname}
                  name="lastName"
                  autoComplete="lastName"
                  onChange={updateData}
                  value={data.lastName}
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="email"
                  label={language.email}
                  name="email"
                  autoComplete="email"
                  onChange={updateData}
                  value={data.email}
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  required
                  fullWidth
                  id="mobile"
                  label={language.phone}
                  name="mobile"
                  autoComplete="mobile"
                  onChange={updateData}
                  value={data.mobile}
                  disabled={data.loginType === 'email' ? true : false}
                />
                <TextField
                  variant="outlined"
                  margin="normal"
                  fullWidth
                  id="usertype"
                  label={language.usertype}
                  name="usertype"
                  value={data.usertype}
                  disabled={true}
                />
                {/* {auth.info.profile.usertype == 'driver' ?
                  <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    id="carType"
                    label={language.car_type}
                    name="carType"
                    value={data.carType}
                    disabled={true}
                  />
                  : null} */}
                {auth.info.profile.usertype == 'driver' ?
                  <FormControl variant="outlined" className={classes.formControl}>
                    <Select style={{ marginTop: 20 }}
                      id="carType"
                      value={carType}
                      onChange={handleCarSelect}
                      className={
                        carType === language.select_car
                          ? classes.inputdimmed
                          : classes.input
                      }
                    >
                      <MenuItem
                        value={language.select_car}
                        key={language.select_car}
                      >
                        {language.select_car}
                      </MenuItem>
                      {cartypes.map((car) => (
                        <MenuItem key={car.name} value={car.name}>
                          <img
                            src={car.image}
                            style={{ width: 20 }}
                            className={classes.carphoto}
                            alt="car types"
                          />
                          {car.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>

                  : null}
                {auth.info.profile.usertype == 'driver' ?
                  <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    id="vehicleMake"
                    label={language.vehicle_model_name}
                    name="vehicleMake"
                    onChange={updateData}
                    value={data.vehicleMake}
                  />
                  : null}
                {auth.info.profile.usertype == 'driver' ?
                  <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    id="vehicleModel"
                    onChange={updateData}
                    label={language.vehicle_model_no}
                    name="vehicleModel"
                    value={data.vehicleModel}
                  />
                  : null}
                {auth.info.profile.usertype == 'driver' ?
                  <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    id="vehicleNumber"
                    onChange={updateData}
                    label={language.vehicle_reg_no}
                    name="vehicleNumber"
                    value={data.vehicleNumber}
                  />
                  : null}
                {auth.info.profile.usertype == 'driver' ?
                  <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    id="bankName"
                    onChange={updateData}
                    label={language.bankName}
                    name="bankName"
                    value={data.bankName}
                  />
                  : null}
                {auth.info.profile.usertype == 'driver' ?
                  <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    id="bankAccount"
                    onChange={updateData}
                    label={language.bankAccount}
                    name="bankAccount"
                    value={data.bankAccount}
                  />
                  : null}
                {auth.info.profile.usertype == 'driver' ?
                  <TextField
                    variant="outlined"
                    margin="normal"
                    fullWidth
                    id="bankCode"
                    onChange={updateData}
                    label={language.bankCode}
                    name="bankCode"
                    value={data.bankCode}
                  />
                  : null}
              </div>
              {auth.info.profile.usertype == 'driver' ?
              <div style={{ marginLeft: 10, display: 'flex', flexDirection: 'column' }}>
                <Typography component="h1" variant="h5">
                  {language.documents}
                </Typography>
                <label style={{ color: '#000', marginTop: 5 }}>{language.driver_license}</label>
                <input
                  type='file'
                  onChange={handleLicenseImageAsFile}
                  style={{ marginTop: 5, border: '1px solid #d2d2d2', padding: 10, borderRadius: 5, padding: '18.5px' }}
                />
                <label style={{ color: '#000', marginTop: 5 }}>{language.vehicle_registration}</label>
                <input
                  type='file'
                  onChange={handleLogbookImageAsFile}
                  style={{ marginTop: 5, border: '1px solid #d2d2d2', padding: 10, borderRadius: 5, padding: '18.5px' }}
                />
                <label style={{ color: '#000', marginTop: 5 }}>{language.vehicle_insurance}</label>
                <input
                  type='file'
                  onChange={handleInsuranceImageAsFile}
                  style={{ marginTop: 5, border: '1px solid #d2d2d2', padding: 10, borderRadius: 5, padding: '18.5px' }}
                />
                <label style={{ color: '#000', marginTop: 5 }}>{language.certificate_of_good_conduct}</label>
                <input
                  type='file'
                  onChange={handleCertificateImageAsFile}
                  style={{ marginTop: 5, border: '1px solid #d2d2d2', padding: 10, borderRadius: 5, padding: '18.5px' }}
                />
                <label style={{ color: '#000', marginTop: 5 }}>{language.photo_of_vehicle}</label>
                <input
                  type='file'
                  onChange={handleVehicleImageAsFile}
                  style={{ marginTop: 5, border: '1px solid #d2d2d2', padding: 10, borderRadius: 5, padding: '18.5px' }}
                />
                {/* <label style={{ color: '#000', marginTop: 5 }}>{language.other}</label>
                <input
                  type='file'
                  onChange={handleOthersImageAsFile}
                  style={{ marginTop: 5, border: '1px solid #d2d2d2', padding: 10, borderRadius: 5, padding: '18.5px' }}
                /> */}

              </div>
              :null}
            </div>
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="success"
              className={classes.submit}
            >
              {language.submit}
            </Button>
          </form>
        </div>
        <AlertDialog open={commonAlert.open} onClose={handleCommonAlertClose}>{commonAlert.msg}</AlertDialog>
      </Container>
  );
};

export default MyProfile;